import { ApiService } from "@/utils"

export const rewardServe = {
  getList(params) {
    return ApiService.query("projects/", {
      page: 1,
      size: 20,
      ...params
    })
  },
  getProject(projectId) {
    return ApiService.query(`projects/${projectId}/base/`)
  },
  getBatch(id) {
    return ApiService.query(`batch/${id}/`)
  },
  getGuide(projectId) {
    return ApiService.query(`projects/${projectId}/guide/`)
  },
  applyBookCfgSearchPost(params) {
    return ApiService.post(`rew/apply/book/cfg/searchForMobile`, params)
  },
  getRewProjList: (params) => {
    return ApiService.post(`rew/cfg/searchList`, params)
  },
  getBasisByType(id) {
    return ApiService.query(`rew/apply/basis/cfg/searchByType/${id}`)
  },
  getBatchArea(id) {
    return ApiService.query(`batch/batches/areas/${id}/`)
  },
  getBatchListByProj(id) {
    return ApiService.query(`batch/project/${id}/`)
  },
  getBatchApplyType(id) {
    return ApiService.query(`manage/batches/types/${id}/`)
  },
  getFocalPointByProjectUnit(params) {
    return ApiService.query(`rew/focalPoint/getFocalPointByProjectUnit`, params)
  },
  getFocalPointByProjectUnitAll(params) {
    return ApiService.query(
      `rew/focalPoint/getFocalPointByProjectUnitAll`,
      params
    )
  }
}

export const instServe = {
  list(params) {
    return ApiService.query("inst/", params)
  },
  details(id) {
    return ApiService.query(`inst/${id}/`)
  },
  historic(instId) {
    return ApiService.query(`inst/${instId}/historic/`)
  },
  // 创建工单
  createInst(batchId) {
    return ApiService.post(`inst/?batchId=${batchId}`)
  },
  // 提交工单
  declare(taskId, form) {
    return ApiService.post(`task/${taskId}/declare/`, {
      form,
      comment: "提交申请",
      submitType: "SUBMIT"
    })
  },
  // 暂存
  save(taskId, form) {
    return ApiService.post(`task/data/save/task/?taskId=${taskId}`, form)
  },
  // 重新生成
  recreate(instId) {
    return ApiService.post(`inst/${instId}/recreate/`)
  },
  // 取回
  retrieve(instId) {
    return ApiService.post(`inst/${instId}/retrieve/`, { comment: "取回工单" })
  },
  // 任务详情 => 为了获取权限
  taskDetails(taskId) {
    return ApiService.query(`task/${taskId}/detail/`)
  },
  // 获取公示详情
  getPublic(instId) {
    return ApiService.query(`inst/${instId}/publicity/`)
  },
  checkTalentLevel(pid) {
    return ApiService.query(`rew/rcTalent/lev/?pid=${pid}`)
  },
  //检查是否已经提交过工单被限制多次提交
  checkIsLimit(batchId) {
    return ApiService.query(`inst/isLimit/${batchId}/`)
  }
}
